import { forwardRef, Ref, useEffect, useImperativeHandle, useRef, useState } from "react";
import Dropdown, { ISelectRow } from "../../libs/dropdown/Dropdown";
import { ESectors, TSectorPair } from "../../shared/Consts";
import PortUtils from "../../portlibs/PortUtils";
import EvalText from "../../components/EvalText";
import { Button, IconButton } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import {SectorOptions} from "../../portlibs/SectorUtils"
import * as _ from "lodash"

export type TSectorDistProps = {
    composition:TSectorPair[]|undefined
}
export type TSectorDistRefProps = {
    composition:TSectorPair[]|undefined
}
export default forwardRef((props:TSectorDistProps,ref:Ref<TSectorDistRefProps|undefined>) => {
    const [options,setOptions] = useState<ISelectRow<number>[]>()
    const [portion,setPortion] = useState<string>("0")
    const [comp,setComp] = useState<TSectorPair[]>(props.composition||[])
    const [sector,setSector] = useState<ESectors|"">("")

    useEffect(() => {
        setOptions(SectorOptions.filter(sector => sector.value>=0 && !props.composition?.find(pair => pair[0]==sector.value)))
    }, [])

    useImperativeHandle(ref, () => ({
        get composition() {return comp}
    }))

    const onAdd = () => setComp([...comp, [sector as ESectors, parseFloat(portion)/100]])
    const onDelete = (c:TSectorPair) => () => {
        _.pull(comp, c)
        setComp([...comp])
    }
    const rows = comp.map(c => <div key={c[0]} className="row">
        <div>{PortUtils.sector(c[0])}</div>
        <div>{PortUtils.formatPercent(c[1]*100)}</div>
        <IconButton onClick={onDelete(c)}><CloseOutlined/></IconButton>
    </div>)
        
    const optionSelect = options ? <div className="flex gap-8">
        <Dropdown options={options} className="flex1" label="Sector" value={sector} onChange={s => s!=null && setSector(s)}/>
        <EvalText value={portion} onChange={e=>setPortion(e.target.value)} onEval={v=>setPortion(v)} floatLabel="Portion" label="Portion"/>
        <Button variant="outlined" onClick={onAdd} disabled={sector==""}>Add</Button>
    </div> : null

    const sum = comp.reduce((p,n) => p+n[1], 0)
    return <div className="sectorlist">
        <h4>Sector Compositions ({PortUtils.formatPercent(sum*100 || 0)})</h4>
        {optionSelect}        
        <div className="compositions">{rows}</div>
    </div>
})
